if ($('.id-706').length) {
    var $pageTop = $('<div class="page-top"><div class="container"></div></div>');
    $pageTop.insertAfter('header#header');
    var $container = $pageTop.find('.container');
    var $breadcrumbsWrapper = $('<div class="breadcrumbs-wrapper"></div>');
    $('.breadcrumbs').appendTo($breadcrumbsWrapper);
    $breadcrumbsWrapper.appendTo($container);

    $('h1').first().appendTo($container);
    $('.top-paragraph').appendTo($container);
    $('.top-image').appendTo($container);




    $('.faq-question').on('click', function () {
        const item = $(this).parent();
        const answer = item.find('.faq-answer');

        if (item.hasClass('active')) {
            item.removeClass('active');
            answer.slideUp(200);
        } else {
            $('.faq-item.active').removeClass('active').find('.faq-answer').slideUp(200);
            item.addClass('active');
            answer.slideDown(200);
        }
    });
}

$('.faq-page').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().slideToggle(200);
});